export enum StringCase {
    lower = 'lower',
    upper = 'upper',
};